module.exports = __webpack_public_path__ + "img/chadle_adv_20.f0cd235e.png";